import { UPDATE_NEWS_STATUS_BY_ID } from '@/domain/navigation/features/navigation/hooks/useUpdateNewsStatus/mutations';
import {
  UpdateNewsStatusByIdMutation,
  UpdateNewsStatusByIdMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

export function useUpdateNewsStatus() {
  const [execute, result] = useMutation<
    UpdateNewsStatusByIdMutation,
    UpdateNewsStatusByIdMutationVariables
  >(UPDATE_NEWS_STATUS_BY_ID, {
    refetchQueries: ['getNewsForManager'],
    awaitRefetchQueries: true,
  });

  const newsItemUpdate = useCallback(
    (variables: UpdateNewsStatusByIdMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [newsItemUpdate, result] as const;
}
